import {HttpClient} from '@angular/common/http';
import {Component, ViewChild, AfterViewInit} from '@angular/core';
import {MatPaginator, MatSort,MatTableDataSource, MatDialog, MatDialogConfig} from '@angular/material';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { DataApiService } from '../../../Services/data-api.service';

import { DialogCambiarEstadoConvenioComponent } from '../dialog-cambiar-estado-convenio/dialog-cambiar-estado-convenio.component';

/** @title Table retrieving data through HTTP */

const itemPerPage=null;

@Component({
  selector: 'app-activar-convenios',
  templateUrl: './activar-convenios.component.html',
  styleUrls: ['./activar-convenios.component.scss']
})
export class ActivarConveniosComponent implements AfterViewInit {
  displayedColumns: string[] = ['id', 'nombre_comercial', 'ruc','created_at','convenio','customColumn1'];
  exampleDatabase: ExampleHttpDatabase | null;
  data: GithubIssue[] = [];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  itemPerPage = 15;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private http: HttpClient,
    private dialog: MatDialog,
    private dataApi:DataApiService) {}  

  findCompany(e){
    const value = e.target.value=="" ? "all": e.target.value;
    this.resetTable(value);
  }

  resetTable(value){
    this.exampleDatabase = new ExampleHttpDatabase(this.http,this.dataApi);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.exampleDatabase!.getRepoIssues(
            this.sort.active, this.sort.direction, this.paginator.pageIndex,value);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;

          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  }
  ngAfterViewInit() {
    this.resetTable("all");
    
    
  } 

  /*Edicion de usuarios */
  dialogCambiarEstadoConvenio(e){    
    this.dialog.open(DialogCambiarEstadoConvenioComponent,{
      width:"200px",
      data:{idUser:e},
      disableClose: false,
      autoFocus:true
    }); 
  }
}

export interface GithubApi {
  items: GithubIssue[];
  total_count: number;
}

export interface GithubIssue {
  id: number;
  nombre_comercial: string;
  ruc: string;
  created_at:any;
  convenio:number;
}

/** An example database that the data source uses to retrieve data for the table. */
export class ExampleHttpDatabase{
  constructor(
    private http: HttpClient,
    private dataApi:DataApiService
  ) {}

  getRepoIssues(sort: string, order: string, page: number,value:any): Observable<GithubApi> {
    const href = this.dataApi.url;
    const requestUrl =
        `${href}/showUsersConvenio/${page + 1}/15/${value}`;

    return this.http.get<GithubApi>(requestUrl);
  }
  
}
